import React, { useState, useEffect, Fragment, useCallback, useRef } from 'react'
import AuthServices from '../../../Api/Auth/AuthServices'
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Collapse,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Checkbox
} from '@mui/material';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import Colors from '../../../Assets/Styles/Colors';
import moment from 'moment';
import {
  Edit,
  FilterAltTwoTone,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  RemoveRedEye,
  QuestionAnswer
} from '@mui/icons-material';
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { CircleLoading } from '../../../Components/Loaders/CircleLoading';
import SelectField from '../../../Components/Fields/SelectField';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.module.css"
import "../../../../App.css"

const tableHead = [
  "Posted By",
  "Role",
  "Category",
  "Job Title",
  "Created At",
  "Valid Till",
  "No. of Proposals",
  "Job Status",
  "Featured",
  "Actions"
];

function DataFilter(props) {
  const {
    usersData,
    categoriesData,
    name,
    role,
    selectedCategory,
    status,
    createdAtStartDate,
    createdAtEndDate,
    validTillStartDate,
    validTillEndDate,
    setName,
    setRole,
    setSelectedCategory,
    setStatus,
    setCreatedAtDateRange,
    setValidTillDateRange,
    sortData,
    categoryContainerRef,
    handleCategoryScroll,
  } = props;
  console.log("🚀 ~ DataFilter ~ usersData:", usersData)
  const [filterCollapse, setFilterCollapse] = useState(true);

  const rolesData = [
    {
      name: "Individual",
      id: 1
    },
    {
      name: "Service Provider",
      id: 2
    },
    {
      name: "Service Seeker",
      id: 3
    },
  ]

  const statusData = [
    {
      name: "Completed",
      id: 1
    },
    {
      name: "Pending",
      id: 2
    },
    {
      name: "Active",
      id: 3
    },
    {
      name: "Posted",
      id: 3
    },
    {
      name: "Featured",
      id: 4
    },
  ]

  // const handleSearch = (e) => {
  //   if (e.key == "Enter") {
  //     filterData("", "", name, selectedIndustry, "", selectedNumber);
  //   }
  // }

  const filterData = () => {
    // sortData("", "", name, selectedIndustry.id, "", selectedNumber);
    sortData("", "", name?.id, "", role, selectedCategory?.id, createdAtStartDate ? new Date(createdAtStartDate) : "",
      createdAtEndDate ? new Date(createdAtEndDate) : "", validTillStartDate ? new Date(validTillStartDate) : "", validTillEndDate ? new Date(validTillEndDate) : "", status);
  };

  const clearData = () => {
    setName(null);
    setRole(null);
    setSelectedCategory(null);
    setCreatedAtDateRange([null, null]);
    setValidTillDateRange([null, null]);
    setStatus(null);
    sortData();
  };

  return (
    <Box sx={{ bgcolor: Colors.white, p: 2, borderRadius: "12px", mt: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body1" fontWeight="bold" color="initial">
          Filters
        </Typography>
        <IconButton
          onClick={() => setFilterCollapse(!filterCollapse)}
          color="primary"
        >
          <FilterAltTwoTone sx={{ color: Colors.primary }} />
        </IconButton>
      </Box>

      <Collapse in={filterCollapse}>
        <Grid container spacing={2} alignItems={"flex-end"}>
          {/* <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={usersData}
                value={name}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                }
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  console.log("🚀 ~ DataFilter ~ event:", event.target.value)
                  if (newValue) {
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                    setName({ id: newValue?.id, name: newValue?.name })
                  } else if (newValue == null) {
                    setName(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Posted by"
                  />
                )}
              />
            </FormControl>
          </Grid> */}

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={rolesData.map((item) => item.name)}
                value={role}
                onChange={(event, newValue) => {
                  console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  console.log("🚀 ~ DataFilter ~ event:", event.target.value)
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setRole(newValue);
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  } else if (newValue == null) {
                    setRole(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Role"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                ref={categoryContainerRef}
                options={categoriesData}
                value={selectedCategory}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                }
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setSelectedCategory({ name: newValue?.name, id: newValue?._id });
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  } else if (newValue == null) {
                    setSelectedCategory(null);
                  }
                }}
                onScroll={() => handleCategoryScroll()}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category"
                  />
                )}
              />
            </FormControl>
          </Grid>

          {/* <Grid item md={4.5}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Typography>Created At From</Typography>
                <TextField
                  fullWidth
                  type='date'
                  value={createdDateFrom}
                  onChange={(e) => setCreatedDateFrom(e.target.value)}
                />
              </Grid>
              <Grid item md={6}>
                <Typography>Created At To</Typography>
                <TextField
                  fullWidth
                  type='date'
                  value={createdDateTo}
                  onChange={(e) => setCreatedDateTo(e.target.value)}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4.5}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Typography>Valid Till From</Typography>
                <TextField
                  fullWidth
                  type='date'
                  value={validDateFrom}
                  onChange={(e) => setValidDateFrom(e.target.value)}
                />
              </Grid>
              <Grid item md={6}>
                <Typography>Valid Till To</Typography>
                <TextField
                  fullWidth
                  type='date'
                  value={validDateTo}
                  onChange={(e) => setValidDateTo(e.target.value)}
                />
              </Grid>
            </Grid>
          </Grid> */}

          <Grid item md={4}>
            <DatePicker
              showIcon
              toggleCalendarOnIconClick
              selectsRange={true}
              startDate={createdAtStartDate}
              endDate={createdAtEndDate}
              onChange={(update) => {
                setCreatedAtDateRange(update);
              }}
              isClearable={true}
              placeholderText="Created At"
              icon={
                <svg
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                >
                  <path d="M4 .5a.5.5 0 00-1 0V1H2a2 2 0 00-2 2v1h16V3a2 2 0 00-2-2h-1V.5a.5.5 0 00-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 110 2H0v2a2 2 0 002 2h12a2 2 0 002-2V9h-6a1 1 0 110-2h6z" />
                </svg>
              }
            />
          </Grid>

          <Grid item md={4}>
            <DatePicker
              showIcon
              toggleCalendarOnIconClick
              selectsRange={true}
              startDate={validTillStartDate}
              endDate={validTillEndDate}
              onChange={(update) => {
                setValidTillDateRange(update);
              }}
              isClearable={true}
              placeholderText="Valid Till"
              icon={
                <svg
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                >
                  <path d="M4 .5a.5.5 0 00-1 0V1H2a2 2 0 00-2 2v1h16V3a2 2 0 00-2-2h-1V.5a.5.5 0 00-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 110 2H0v2a2 2 0 002 2h12a2 2 0 002-2V9h-6a1 1 0 110-2h6z" />
                </svg>
              }
            />
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={statusData.map((item) => item.name)}
                value={status}
                onChange={(event, newValue) => {
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setStatus(newValue);
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  } else if (newValue == null) {
                    setStatus(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4} display="flex" justifyContent="flex-end">
            <Button
              onClick={clearData}
              variant="outlined"
              sx={{
                mx: 1,
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%), 
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Clear
            </Button>
            <Button
              onClick={filterData}
              variant="contained"
              sx={{
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%),
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Collapse>
    </Box>
  );
}

function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

function Jobs() {
  const [loading, setLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [featuredOpen, setFeaturedOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [categoryPage, setCategoryPage] = useState(1);
  const [categoryPerPage, setCategoryPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState(null);
  const [role, setRole] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [status, setStatus] = useState("")
  const [createdAtDateRange, setCreatedAtDateRange] = useState([null, null]);
  const [createdAtStartDate, createdAtEndDate] = createdAtDateRange;
  const [validTillDateRange, setValidTillDateRange] = useState([null, null]);
  const [validTillStartDate, validTillEndDate] = validTillDateRange;

  const { state } = useLocation();
  const navigate = useNavigate();
  const categoryContainerRef = useRef();

  const getAllJobs = async (page, rows, userId, adId, role, category, createdAtFrom, createdAtTo, validTillFrom, validTillTo, status) => {
    setLoading(true)
    try {
      let result = await AuthServices.getAllJobs(
        page ? page : 1,
        rows ? rows : 10,
        userId ? userId : "",
        adId ? adId : "",
        role ? role : "",
        category ? category : "",
        createdAtFrom ? createdAtFrom : "",
        createdAtTo ? createdAtTo : "",
        validTillFrom ? validTillFrom : "",
        validTillTo ? validTillTo : "",
        status ? status : ""
      );
      if (result?.responseCode == 200) {
        setJobs(result.data.ads);
        setCount(result?.data?.totalAds)
      }
      console.log("🚀 ~ getAllJobs ~ result.data.ads):", result.data.ads)
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  }

  const getAllUsers = async (page, rows, name, industry, service, phone, role) => {
    try {
      let result = await AuthServices.getAllUsers(
        page ? page : 1,
        rows ? rows : 10,
        name ? name : "",
        industry ? industry : "",
        service ? service : "",
        phone ? phone : "",
        role ? role : "",
      );
      if (result.responseCode == 200) {
        console.log("result =>", result)
        const arrayOfUsers = result?.data?.users?.map((item) => ({ name: item?.name, id: item?._id }));
        console.log("🚀 ~ getAllUsers ~ arrayOfUsers:", arrayOfUsers)
        setUsers(arrayOfUsers);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getAllCategories = async (reset = false) => {
    try {
      setCategoryLoading(true)
      let result = await CategoriesServices.getAllCategories("", categoryPage, categoryPerPage, "adbazaar");
      if (result.responseCode == 200) {
        const filteredCategories = result?.data?.categories?.filter((item) => item.isActive == true);
        if (reset) {
          setCategories(filteredCategories);
        } else {
          setCategories(prevCategories => [...prevCategories, ...filteredCategories]);
        }
        console.log("🚀 ~ getAllCategories ~ filteredCategories:", filteredCategories)
        setCategories(filteredCategories)
      }
    } catch (error) {
      setCategoryLoading(false);
      console.log(error);
    }
  }

  const approveAd = async () => {
    const obj = {
      isApproved: true,
    }
    try {
      const result = await AuthServices.approveAd(id, obj);
      console.log(result);
    } catch (error) {
      console.log(error)
    }
    finally {
      getAllJobs();
    }
  }

  const DisApproveAd = async () => {
    const obj = {
      isApproved: false,
    }
    try {
      const result = await AuthServices.approveAd(id, obj);
      console.log(result);
    } catch (error) {
      console.log(error)
    }
    finally {
      getAllJobs();
    }
  }

  const approveFeatured = async () => {
    const obj = {
      featured: true,
    }
    try {
      const result = await AuthServices.approveFeature(id, obj);
      console.log("🚀 ~ approveFeatured ~ result:", result)
      // setIsChecked(true);
    } catch (error) {
      console.log(error)
    }
    finally {
      getAllJobs();
    }
  }

  const disApproveFeatured = async () => {
    const obj = {
      featured: false,
    }
    try {
      const result = await AuthServices.approveFeature(id, obj);
      console.log("🚀 ~ disApproveFeatured ~ result:", result)
      // setIsChecked(false);
    } catch (error) {
      console.log(error)
    }
    finally {
      getAllJobs();
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllJobs(newPage + 1, rowsPerPage, name?.id, "", role, selectedCategory?.id, createdAtStartDate, createdAtEndDate, validTillStartDate, validTillEndDate, status);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getAllJobs(page, event.target.value, name?.id, "", role, selectedCategory?.id, createdAtStartDate, createdAtEndDate, validTillStartDate, validTillEndDate, status);
  };

  const sort = (page, rows, userId, adId, role, category, createdAtFrom, createdAtTo, validTillFrom, validTillTo, status) => {
    getAllJobs(page, rows, userId, adId, role, category, createdAtFrom, createdAtTo, validTillFrom, validTillTo, status)
  }

  const loadMoreCategories = useCallback(() => {
    setCategoryPage((prevPage) => prevPage + 1);
  }, []);

  const handleCategoryScroll = () => {
    if (!categoryContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = categoryContainerRef.current;
    console.log("🚀 ~ handleCategoryScroll ~ scrollTop, scrollHeight, clientHeight:", scrollTop, scrollHeight, clientHeight)

    if (scrollTop + clientHeight >= scrollHeight - 5 && !categoryLoading) {
      loadMoreCategories();
    }
  };

  useEffect(() => {
    getAllCategories();
  }, [categoryPage]);

  useEffect(() => {
    getAllJobs("", "", "", state?.id ? state?.id : "");
    getAllCategories(true);
    getAllUsers();
  }, [])

  return (
    <Fragment>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        action={approveAd}
        title={"Approve Ad"}
        btn={"Approve"}
        secBtn={"Disapprove"}
        secAction={DisApproveAd}
      />
      <ConfirmationDialog
        open={featuredOpen}
        onClose={() => setFeaturedOpen(false)}
        action={approveFeatured}
        title={"Approve Featured"}
        btn={"Yes"}
        secBtn={"No"}
        secAction={disApproveFeatured}
      />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Jobs
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Jobs"]} />
          </Grid>
        </Grid>
        <DataFilter
          categoriesData={categories}
          usersData={users}
          name={name}
          role={role}
          selectedCategory={selectedCategory}
          status={status}
          createdAtStartDate={createdAtStartDate}
          createdAtEndDate={createdAtEndDate}
          validTillStartDate={validTillStartDate}
          validTillEndDate={validTillEndDate}
          setName={setName}
          setRole={setRole}
          setSelectedCategory={setSelectedCategory}
          setStatus={setStatus}
          setCreatedAtDateRange={setCreatedAtDateRange}
          setValidTillDateRange={setValidTillDateRange}
          sortData={(
            page,
            rows,
            userId,
            adId,
            role,
            category,
            createdAtFrom,
            createdAtTo,
            validTillFrom,
            validTillTo,
            status) =>
            sort(
              page,
              rows,
              userId,
              adId,
              role,
              category,
              createdAtFrom,
              createdAtTo,
              validTillFrom,
              validTillTo,
              status
            )
          }
          categoryContainerRef={categoryContainerRef}
          handleCategoryScroll={handleCategoryScroll}
        />
        <Box>
          {loading ? (
            <CircleLoading />
          ) : (
            <Fragment>
              <TableContainer
                component={Paper}
                sx={{
                  // width: "calc(100vw - 320px)",
                  "&::-webkit-scrollbar": {
                    bgcolor: Colors.white,
                    height: "8px",
                    borderRadius: "10px",
                    cursor: "pointer",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bgcolor: Colors.primary,
                    borderRadius: "10px",
                    cursor: "pointer",
                  },
                  "&.MuiPaper-root": {
                    borderRadius: "12px",
                    mt: 2,
                    boxShadow: 0,
                  },
                }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: Colors.lightGray }}>
                      {tableHead.map((item, index) => (
                        // <TableCell
                        //   key={index}
                        //   colSpan={item == "Posted By" ? 2 : 1}
                        //   rowSpan={item == "Posted By" ? 2 : 1}
                        // >
                        //   <Typography
                        //     sx={{
                        //       fontWeight: "bold",
                        //       textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                        //       width: "130px"
                        //     }}
                        //   >
                        //     {item}
                        //   </Typography>
                        //   {item == 'Posted By' && (
                        //     <Typography sx={{ width: "100%", display: "flex" }}>
                        //       <Typography sx={{ width: "50%" }}>Name</Typography>
                        //       <Typography sx={{ width: "50%" }}>Role</Typography>
                        //     </Typography>
                        //   )}
                        // </TableCell>
                        <TableCell key={index}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              // textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                              width: "130px",
                            }}
                          >
                            {item}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {jobs.map((row, index) => (
                      <TableRow
                        key={index}
                        // onClick={() => {
                        //   navigate("/proposals", { state: { id: row?._id } })
                        // }}
                        sx={{
                          transition: ".3s all ease-in-out",
                          ":hover": {
                            backgroundColor: Colors.primaryLight,
                            cursor: "pointer"
                          }
                        }}
                      >
                        <TableCell>
                          {row?.postedBy?.name}
                        </TableCell>
                        <TableCell>
                          {row?.postedBy?.roles}
                        </TableCell>
                        <TableCell>
                          {row?.category[0]?.name}
                        </TableCell>
                        <TableCell>
                          {row?.title}
                        </TableCell>
                        <TableCell>
                          {moment(row?.createdAt).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell>
                          {moment(row?.valid_till).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center", }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              cursor: "pointer",
                              textDecoration: "underline",
                              color: Colors.purple,
                            }}
                            component={"a"}
                            onClick={() => navigate("/proposals", { state: { id: row?._id } })}
                          >
                            {row?.totalProposals}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={
                              row?.isHired == true && row?.isCompleted == true ?
                                "Completed"
                                : row?.isHired == true ?
                                  "Active"
                                  : row?.isApproved == null ?
                                    "Pending"
                                    : row?.isApproved == true ?
                                      "Posted"
                                      : "Disapproved"
                            }
                            sx={{
                              bgcolor:
                                row?.isHired == true && row?.isCompleted == true ? Colors.gunMetal
                                  : row?.isApproved == null ? Colors.danger + 26
                                    : row.isApproved == true ? Colors.success + 26
                                      : Colors.pending + 26,
                              color:
                                row?.isHired == true && row?.isCompleted == true ? Colors.white
                                  : row?.isApproved == null ? Colors.danger
                                    : row?.isApproved == true ? Colors.success
                                      : Colors.pending,
                              height: 26,
                              textTransform: 'capitalize',
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Featured">
                            <Checkbox
                              checked={row?.featured}
                              onClick={(e) => {
                                e.stopPropagation();
                                setFeaturedOpen(true);
                                setId(row?._id)
                              }}
                            />
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Tooltip title="Status">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setId(row?._id)
                                  setOpen(true);
                                }}
                              >
                                <Edit sx={{ color: Colors.success }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="View">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/job-details/${row._id}`, { state: row })
                                }}
                              >
                                <RemoveRedEye sx={{ color: Colors.primary }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Chats">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/conversations", { state: { userId: row?.postedBy?._id, adId: row?._id } });
                                }}
                              >
                                <QuestionAnswer sx={{ color: Colors.primary }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Table sx={{ marginTop: "12px" }}>
                <TablePagination
                  sx={{
                    borderBottom: "none",
                    bgcolor: Colors.white,
                    borderRadius: "12px",
                  }}
                  rowsPerPageOptions={[10, 20, 30]}
                  colSpan={12}
                  count={+count}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Table>
            </Fragment>
          )}
        </Box>
      </Box>
    </Fragment >
  )
}

export default Jobs